import { createSlice } from "@reduxjs/toolkit";
import { adminChangePassword } from "./thunk";

interface AdminPasswordState {
    loading: boolean;
    error: string | null;
    success: boolean;
    tempPassword: string | null;
    emailSent: boolean;
}

const initialState: AdminPasswordState = {
    loading: false,
    error: null,
    success: false,
    tempPassword: null,
    emailSent: false,
};

const adminPasswordSlice = createSlice({
    name: "adminPassword",
    initialState,
    reducers: {
        clearAdminPasswordState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.tempPassword = null;
            state.emailSent = false;
        },
    },
    extraReducers: (builder) => {
        // Admin Change Password
        builder.addCase(adminChangePassword.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
            state.tempPassword = null;
            state.emailSent = false;
        });
        builder.addCase(adminChangePassword.fulfilled, (state, action) => {
            state.loading = false;
            state.success = true;
            state.tempPassword = action.payload?.data?.temp_password || null;
            state.emailSent = action.payload?.data?.email_sent || false;
        });
        builder.addCase(adminChangePassword.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "Failed to change password";
            state.success = false;
            state.tempPassword = null;
            state.emailSent = false;
        });
    },
});

export const { clearAdminPasswordState } = adminPasswordSlice.actions;
export default adminPasswordSlice.reducer;
